import React, { forwardRef } from "react";
import DatePicker from "react-datepicker";
import { Input } from 'reactstrap';
import "react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { useRef } from "react";

const DatePickerControl = ({ onFocus, onBlur, ...props }) => {
    const refCustomInput = useRef();

     //Custom input
    const CustomInput = forwardRef((props, ref) => {
        const { autoFocus,value, ...rest } = props;

        return (
            <div style={{ display: 'flex' }}  >
                <Input autoComplete="off" ref={ref} value={value}{...rest} />
                <FontAwesomeIcon style={{ position:'absolute' , right: '20px', top: '10px' }} icon={faCalendarAlt} onClick={props.onClick} />
       </div>
        );
    });

    return (
        <div style={{ width: '100%',position: 'relative'}}>
            <DatePicker 
                strictParsing={true}    
                selected={props.selected}
                dateFormat="dd/MM/yyyy"
                autoComplete="off"
                customInput={<CustomInput ref={refCustomInput} value={props.selected} min={props.minDate} />}
                onFocus={evt => {
                     //Notify parent
                    if (onFocus) {
                        onFocus.call(this, evt);
                    }
                }}
                onBlur={evt => {
                    //Notify parent
                    if (onBlur) {
                        onBlur.call(this, evt);
                    }
                }}
                {...props}
            />
       </div>
    );
};

export default DatePickerControl;

